jQuery(document).ready(function ($) {
    $('.toggle-element-button').on('click', function (e) {
        e.preventDefault();
        var $button = $(this);
        var elementId = $button.data('element-id');
        var $element = $('#' + elementId);
        var className = 'toggle-' + elementId;

        if ($element.length) {
            $element.toggleClass('toggle-on');
            $('body').toggleClass(className);
            $button.toggleClass('on');
        } else {
            alert('Element with ID "' + elementId + '" not found.');
        }
    });

    $(document).on('loginModal:beforeOpen', function (e) {
        $('.toggle-on').removeClass('toggle-on');

        $('.toggle-element-button.on').removeClass('on');

        $('body').removeClass(function (index, className) {
            return (className.match(/(^|\s)toggle-\S+/g) || []).join(' ');
        });
    });
});